import * as actions from './inf-chg-save.actions';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, from } from 'rxjs';
import { SpxToasterAutoCloseSpeedEnum, spxToasterActions } from '@softpak/components/spx-toaster';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { loadingChgSave, textChangeDetails, textSave } from 'src/app/shared/_config/i18n/i18n-interface';

import { ApiInfMethod } from 'src/app/api/api-methods.inf';
import { Injectable, inject } from '@angular/core';
import { SharedErrorObjectI } from 'src/app/shared/models/shared/shared-error-object.interface';
import { SharedGenericService } from 'src/app/shared/services/shared-generic.service';
import { SpxCapitalizePipe } from '@softpak/components/spx-capitalize';
import { TranslateService } from '@ngx-translate/core';
import { spxSpinnerActions } from '@softpak/components/spx-spinner';

@Injectable()
export class InfChgSaveEffects {
    private readonly actions$ = inject(Actions);
    private readonly sharedGenericService = inject(SharedGenericService);
    private readonly translateService = inject(TranslateService);

    load$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(actions.load),
        mergeMap(action => from(this.sharedGenericService.invoke(ApiInfMethod.infChgSave, action.query))
        .pipe(
            map(result => actions.received({
                result
            })),
            catchError((error: SharedErrorObjectI) => {
                console.error(error);
                return [
                    actions.error({
                        error
                    }),
                    spxToasterActions.createError({
                        autoClose: error.autoclose ? 5000 : undefined,
                        messageText: error.message,
                    }),
                ];
            })
        )))
    );

    afterLoad$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(actions.load),
        mergeMap(() => [
            spxSpinnerActions.show({
                action: loadingChgSave
            }),
        ]))
    );

    afterError$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(actions.error),
        mergeMap(() => [
            spxSpinnerActions.hide({
                 action: loadingChgSave
            }),
        ]))
    );

    afterReceived$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(actions.received),
        mergeMap(() => [
            spxSpinnerActions.hide({
                 action: loadingChgSave
            }),
            spxToasterActions.createSuccess({
                autoClose: SpxToasterAutoCloseSpeedEnum.DEFAULT,
                messageText: SpxCapitalizePipe.transform(this.translateService.instant(textSave)),
                title: SpxCapitalizePipe.transform(this.translateService.instant(textChangeDetails)),
            }),
            actions.reset({}),
        ]))
    );
}
